import React, { memo } from 'react';

import { SimpleTooltip } from '@eluve/components';
import { Icon, cn } from '@eluve/components';

interface MemoizedUtteranceSplitterProps {
  utteranceId: string;
  fragmentId: string;
  tooltipLabel: string;
  onSplit: (params: { utteranceId: string; fragmentId: string }) => void;
  explicitlyVisible?: boolean;
}

export const MemoizedUtteranceSplitter = memo(
  ({
    utteranceId,
    fragmentId,
    tooltipLabel,
    onSplit,
    explicitlyVisible,
  }: MemoizedUtteranceSplitterProps) => {
    return (
      <div
        className={cn(
          'w-0.5 cursor-pointer',
          {
            'invisible -translate-x-4 opacity-0 transition-all duration-300 group-hover:visible group-hover:block group-hover:size-6 group-hover:translate-x-0.5 group-hover:opacity-100':
              !explicitlyVisible,
          },
          {
            'block size-6': explicitlyVisible,
          },
        )}
      >
        <SimpleTooltip label={tooltipLabel}>
          <div
            onClick={(e) => {
              // Stop event propagation to prevent the parent from receiving the click
              e.stopPropagation();
              e.preventDefault();
              onSplit({
                utteranceId,
                fragmentId,
              });
            }}
          >
            <Icon
              size="xl"
              name={explicitlyVisible ? 'CornerDownLeft' : 'SeparatorVertical'}
            />
          </div>
        </SimpleTooltip>
      </div>
    );
  },
);
